// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { ComponentWrapper, ElementWrapper } from "@cloudscape-design/test-utils-core/selectors";
import LoadingBarWrapper from "../loading-bar";
import chatBubbleStyles from "../../../chat-bubble/styles.selectors.js";
import loadingBarStyles from "../../../loading-bar/styles.selectors.js";
export default class ChatBubbleWrapper extends ComponentWrapper {
  static rootSelector: string = chatBubbleStyles.root;
  findAvatarSlot() {
    const isAvatarHidden = !!this.find(`.${chatBubbleStyles.avatar}.${chatBubbleStyles.hide}`);
    return isAvatarHidden ? null : this.findByClassName(chatBubbleStyles.avatar);
  }
  findContentSlot() {
    return this.findByClassName(chatBubbleStyles.content);
  }
  findActionsSlot() {
    return this.findByClassName(chatBubbleStyles.actions);
  }
  findLoadingBar() {
    return this.findComponent(`.${chatBubbleStyles["message-area"]} .${loadingBarStyles.root}`, LoadingBarWrapper);
  }
}